import { render } from "./Text.vue?vue&type=template&id=2f4171b6&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=2f4171b6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4171b6"],['__file',"src/scripts/view/portfolio/sections/modules/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f4171b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f4171b6', __exports__)) {
    api.reload('2f4171b6', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=2f4171b6&scoped=true", () => {
    api.rerender('2f4171b6', render)
  })

}


export default __exports__